const FONT = "'DM Sans', sans-serif";

type Props = { slug: string; cupomCodigo?: string | null };

export default function ShareButton({ slug, cupomCodigo }: Props) {
  const handleClick = () => {
    const fromUrl = (() => {
      try {
        const raw = new URLSearchParams(window.location.search).get('cupom') || '';
        return raw.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 24);
      } catch { return ''; }
    })();
    const fromSession = (() => {
      try { return sessionStorage.getItem(`inspira-cupom-${slug}`) || ''; }
      catch { return ''; }
    })();
    const cupom = (cupomCodigo || fromUrl || fromSession || '').toUpperCase();
    const qs = cupom ? `?cupom=${encodeURIComponent(cupom)}` : '';
    const url = `https://www.inspiramusicas.com.br/ouvir-musica/${slug}${qs}`;
    const text = `Oi! Pode me ajudar a pagar a música personalizada da Inspira Músicas? Aqui é o link pra escolher e pagar: ${url}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      style={{
        padding: '14px 12px',
        borderRadius: 999,
        background: 'var(--gold-pale)',
        color: 'var(--amber-deep)',
        border: '1.5px solid var(--gold-border)',
        fontWeight: 700,
        fontSize: 13.5,
        fontFamily: FONT,
        cursor: 'pointer',
        transition: 'all 0.18s',
      }}
    >
      💸 Pedir para alguém pagar
    </button>
  );
}
